module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<ul class="validator">\n    ';
 data.requirements.forEach(function(requirement) { ;
__p += '\n        <li id="' +
((__t = ( requirement.id )) == null ? '' : __t) +
'" class="' +
((__t = ( requirement.className )) == null ? '' : __t) +
'">' +
((__t = ( requirement.title )) == null ? '' : __t) +
'</li>\n    ';
 }); ;
__p += '\n</ul>\n';
return __p
}